import {TableRow, TableCell, Checkbox} from '@carbon/react';
import getFormatter from '../../../../lib/formatter';
import {TableHeader} from './types';

export interface ProviderTableRowProps {
    row: any;
    visibleColumns: string[];
    tableHeaders: TableHeader[];
    existingProviderIds: Set<string>;
    selectionSet: Set<string>;
    deselectionSet: Set<string>;
    getRowProps: (row: any) => any;
    onCheckboxChange: (rowId: string, checked: boolean, isExisting: boolean) => void;
}

export function ProviderTableRow({
    row,
    visibleColumns,
    tableHeaders,
    existingProviderIds,
    selectionSet,
    deselectionSet,
    getRowProps,
    onCheckboxChange
}: ProviderTableRowProps) {
    const rowProps = getRowProps({row});
    const existingProvider = existingProviderIds.has(row.id);
    const checked = !existingProvider ? selectionSet.has(row.id) : !deselectionSet.has(row.id);

    return (
        <TableRow {...rowProps} className={checked ? 'checked-row' : ''} style={{boxSizing: 'border-box', height: '100%'}}>
            <TableCell className='select-col' key={`select-${row.id}`}>
                <Checkbox
                    id={`check-${row.id}`}
                    labelText=''
                    checked={checked}
                    onChange={(_, {checked}) => {
                        onCheckboxChange(row.id, checked, existingProvider);
                    }}
                />
            </TableCell>
            {row.cells.filter((cell: any) => visibleColumns.includes(cell.id.split(':')[1])).map((cell: any) => {
                const header = tableHeaders.find(h => h.key === cell.id.split(':')[1]);
                const formatter = header?.type ? getFormatter(header.type, header.precision) : {format: (value: any) => value};
                return (
                    <TableCell key={cell.id}>
                        {formatter.format(cell.value)}
                    </TableCell>
                );
            })}
        </TableRow>
    );
}
